import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import { updateCandidate } from '../../../api/candidate';
import useNotification from '../../../hooks/useNotification';
import Input from '../../common/input';
import Section from '../../common/section';

const Edit = (props) => {
  const notification = useNotification();
  const isEnabled = useRouteMatch({
    path: '/candidates/:hash/edit',
    exact: true,
  });
  const { hash } = useParams();
  let { current: lastSaved } = useRef(props.overview);
  const [overview, setOverview] = useState(props.overview);

  function handleSubmit() {
    if (lastSaved !== overview) {
      updateCandidate(hash, {...props, immediately: true, overview:overview, role: props.role.hash}).then((res) => {
        if (res.success) {
          props.reloadCandidateUpdatedAtData()
          notification.success({
            message: "Candidate's overview was successfully updated",
          });
          lastSaved = overview;
        } else notification.error(res.error);
      });
    }
  }

  return (
    <Section title="Overview" disabled={!isEnabled}>
      <Input
        placeholder="type a candidate profile overview here"
        textarea
        rows={15}
        value={overview}
        onChange={({ target }) => setOverview(target.value)}
        onBlur={handleSubmit}
      />
    </Section>
  );
};

Edit.defaultProps = {
  overview: '',
};

Edit.propTypes = {
  overview: PropTypes.string,
};

export default Edit;
